export default {
  L_USER_TITLE: "Danh sách người dùng",

  OBJ_USER_TABLE_COL: {
    userName: "Người dùng",
    email: "Email",
    phoneNumber: "Số điện thoại",
    createdAt: "Ngày tạo",
    status: "Trạng thái",
    action: "Thao tác",
  },

  OBJ_USER_INPUT_SEARCH: {
    search: "Tìm kiếm: Tên người dùng",
    status: "Trạng thái",
  },
  MSG_RESET_PW: "Mật khẩu đã được cập nhật là @SecuredGateway",
};
